import { create } from 'zustand';
import type { MeResponse } from '../api';

interface AppState {
  me: MeResponse | null;
  setMe: (me: MeResponse | null) => void;

  /** Снимок избранных skin uuids, чтобы быстро чекать в списках */
  favorites: Set<string>;
  setFavorites: (set: Set<string>) => void;
  toggleFavoriteLocal: (uuid: string) => void;
}

export const useApp = create<AppState>((set) => ({
  me: null,
  setMe: (me) => set({ me }),

  favorites: new Set(),
  setFavorites: (s) => set({ favorites: new Set(s) }),
  toggleFavoriteLocal: (uuid) =>
    set((state) => {
      const next = new Set(state.favorites);
      if (next.has(uuid)) next.delete(uuid);
      else next.add(uuid);
      return { favorites: next };
    }),
}));
